// extracted by mini-css-extract-plugin
export var top = "Contact-module--top--EbXqC";
export var left = "Contact-module--left--1-2HS";
export var right = "Contact-module--right--sLIvc";
export var right_image = "Contact-module--right_image--2jYhK";
export var texts = "Contact-module--texts--37sLr";
export var right_contacts = "Contact-module--right_contacts--2iHgL";
export var right_mobile_link = "Contact-module--right_mobile_link--3enFz";
export var bottom = "Contact-module--bottom--2Om3o";